/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import {
  CloudEditResponse, CloudPriceResponse, DashboardState, GetServerResponse,
} from './types';
import { MutationRequestStatus, RootState } from '../types';

export const getters: GetterTree<DashboardState, RootState> = {
  gamecloudEditInfo(state): CloudEditResponse {
    return state.gamecloudEdit;
  },
  cloudPrice(state): CloudPriceResponse {
    return state.cloudPrice.data;
  },
  editOrderLoading(state): boolean {
    return state.editOrder.status === MutationRequestStatus.LOADING;
  },
  editOrderFailure(state): boolean {
    return state.editOrder.status === MutationRequestStatus.ERROR;
  },
  server(state): GetServerResponse {
    return state.getServer.data;
  },
};
